var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#00E471",
    stroke: "#CCCCCC",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9375C0 14.3842 1.29471 13.125 2.89182 13.125C4.48894 13.125 5.78365 14.3842 5.78365 15.9375V27.1875C5.78365 28.7408 4.48894 30 2.89182 30C1.29471 30 0 28.7408 0 27.1875V15.9375Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71191 15.6249V25.8073C7.71191 27.2278 8.53705 28.5262 9.84332 29.1615L9.93943 29.2082C11.0102 29.7289 12.1909 30 13.3881 30H23.8298C25.6678 30 27.2502 28.7383 27.6107 26.9854L29.9242 15.7354C30.4014 13.415 28.5764 11.25 26.1432 11.25H19.2792V3.75C19.2792 1.67893 17.553 0 15.4234 0C14.3587 0 13.4956 0.839475 13.4956 1.875V3.12501C13.4956 4.74778 12.9544 6.32678 11.9533 7.62501L9.25422 11.125C8.25309 12.4232 7.71191 14.0022 7.71191 15.6249Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.ef4f5d6e4673f113f6fde8ec188f0337.svg";
export { ForwardRef as ReactComponent };